import styled from 'styled-components';

export const FilterButtonWrapper = styled.div`
  .filter-button {
    font-family: 'Graphik', serif;
    font-style: normal;
    min-width: 50px;
    background: #2a2b2c;
    border-radius: 13px;
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: white;
    padding: 13px 30px;
    transition: 0.3s;
    cursor: pointer;
    display: flex;
  }
  .filter-button:hover {
    opacity: 0.85;
  }
  .filter-button img {
    margin-right: 8px;
    width: 20px;
  }
`;

export const FilterModalWrapper = styled.div`
  @media (min-width: 376px) {
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 375px) {
    display: flex;
    gap: 10px;
  }

  .filter-modal-select-block {
    margin-top: 20px;
  }
  .filter-modal-select-block .filter-title {
    margin-bottom: 15px;
    font-weight: 600;
    font-size: 17px;
    line-height: 15px;
    letter-spacing: 0.08em;
    color: #a7a3d6;
  }

  .filter-item {
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    color: #0d092b;
    margin-top: 5px;
  }

  .ant-checkbox-inner {
    background: #a7a3d6;
    opacity: 0.6;
    border-radius: 2px;
    border: none;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background: #ffa24b;
    opacity: 1;
  }

  .filter-item-count {
    line-height: 28px;
    color: #7e7e7e;
  }

  .filter-read-more {
    color: #ff8e24;
    margin-top: 10px;
    cursor: pointer;
  }
`;
